import { render, staticRenderFns } from "./CurrenciesSelectBox.vue?vue&type=template&id=486cd44f&scoped=true&"
import script from "./CurrenciesSelectBox.vue?vue&type=script&lang=js&"
export * from "./CurrenciesSelectBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486cd44f",
  null
  
)

export default component.exports